const service = {
    detectCountry() {
        return new Promise(resolve => {
            const browserLocale = navigator.language;
            let browserCountry = null;
            if (browserLocale && browserLocale.length > 0) {
                const delimiterPosition = browserLocale.indexOf('-');
                if (delimiterPosition !== -1) {
                    browserCountry = browserLocale.substring(delimiterPosition + 1);
                } else {
                    browserCountry = browserLocale.toUpperCase();
                }
            }
            resolve(browserCountry);
        });
    },
};
export default {
    install(Vue) {
        Vue.$countryDetectService = service;
        Vue.prototype.$countryDetectService = service;
    },
};
